<template>
	<contentBox v-if="planCurrent">
		<contentTitle label="PLAN" close="home">
			<h2 class="text-white font-weight-light pb-2">{{planName}}</h2>
		</contentTitle>
		<contentBody>
			<div class="p-3">
				<div class="category-body">
					<div class="category">
						<div class="category-title">PLAN DETAILS</div>
						<div class="property-row">
							<label>Status</label>
							<div class="property-value-right">
								{{status}}
							</div>
						</div>
						<div class="property-row">
							<label>Purchased</label>
							<div class="property-value-right">
								{{planCurrent.created | longDate}} @{{planCurrent.created | time}}
							</div>
						</div>
						<div v-if="isDayPass">
							<div v-if="status === 'active'" class="property-row">
								<label>Expires</label>
								<div class="property-value-right">
									{{planExpires | longDate}} @{{planCurrent.created | time}}
								</div>
							</div>
							<div v-if="status === 'expired'" class="property-row">
								<label>Expired</label>
								<div class="property-value-right">
									{{planExpires | longDate}} @{{planCurrent.created | time}}
								</div>
							</div>
							<div class="property-row">
								<button v-on:click="routeUpgrade" class="btn btn-green btn-sm float-right">UPPGRADE PLAN</button>
							</div>
							<div class="property-row" v-if="status === 'expired'">
								<button v-on:click="routeUnlock" class="btn btn-green btn-sm float-right">RENEW DAY PASS</button>
							</div>
						</div>
					</div>
				</div>


			</div>
		</contentBody>
	</contentBox>
</template>

<script>

import contentBox from '../content';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';

const dayTs = 24*60*60*1000;

export default {
	name:'plan',
	props: {},
	components:{
		contentBox,
		contentBody,
		contentTitle
	},
	computed:{
		status:function(){
			if (this.planCurrent.plan.id === 'plan_1') return 'active';
			if (this.planCurrent.plan.id === 'plan_3') return 'active';
			let currentPlanTs = new Date(this.planCurrent.created).getTime();
			let left = (currentPlanTs + dayTs)-this.$data.nowTs;
			if (left > 0) return 'active';
			else return 'expired';
		},
		planCurrent:function(){
			return this.$store.state.plan.current;
		},
		planExpires:function(){
			let currentPlanTs = new Date(this.planCurrent.created).getTime();
			let expires = new Date(currentPlanTs + dayTs).toUTCString();
			return expires;
		},
		planName:function(){
			if (this.planCurrent.plan.id === 'plan_3') return 'Annual Subscription';
			if (this.planCurrent.plan.id === 'plan_2') return 'Day Pass';
			if (this.planCurrent.plan.id === 'plan_1') return 'Studio Subscription';
		},
		isDayPass:function(){
			if (this.planCurrent.plan.id === 'plan_2') return true;
			return false;
		}

	},
	methods:{
		routeClose:function(){
			this.$router.push({
				name:'home'
			});
		},
		routeUnlock:function(){
			this.$router.push({
				name:'unlock'
			});
		},
		routeUpgrade:function(){
			this.$router.push({
				name:'unlock'
			});
		}
	},
	mounted:function(){
		this.$data.nowTs = new Date().getTime();
		this.interval = setInterval(()=>{
			this.$data.nowTs = new Date().getTime();
		},60000);
	},
	data:function(){
		return {
			nowTs:0
		};
	},
	destroyed:function(){
		if (this.interval) clearInterval(this.interval);
	},
};

</script>


// WEBPACK FOOTER //
// src/components/plan/plan.vue